import { toValue } from 'vue';

import { useMetaAdsAccountDetails } from '@/app/dashboards/composables/useMetaAdsAccountDetails';
import { useTikTokAdsAccountDetails } from '@/app/dashboards/composables/useTikTokAdsAccountDetails';
import { CHANNELS } from '@/models/dashboards/channels.enum';

const CONTROLLER_FACTORIES = {
  [CHANNELS.META_ADS.value]: useMetaAdsAccountDetails,
  [CHANNELS.INSTAGRAM.value]: useMetaAdsAccountDetails,
  [CHANNELS.FACEBOOK.value]: useMetaAdsAccountDetails,
  [CHANNELS.TIKTOK_ADS.value]: useTikTokAdsAccountDetails,
  [CHANNELS.TIKTOK.value]: useTikTokAdsAccountDetails,
};

/**
 * @param {import('vue').MaybeRefOrGetter<keyof typeof CONTROLLER_FACTORIES>} channel
 * @returns {ReturnType<(typeof CONTROLLER_FACTORIES)[keyof typeof CONTROLLER_FACTORIES]>}
 */
export function getAdsPlatformController(channel) {
  const composable = CONTROLLER_FACTORIES[toValue(channel)];
  return composable ? composable() : null;
}
